import React, { useState } from 'react';
import "./Subscription_Plan.css";
import { Button } from 'react-bootstrap';
import Subscription_Plan_card from './Subscription_Plan_card/Subscription_Plan_card';
import parse from 'html-react-parser';

function Subscription_Plan({ nextStep, prevStep, all_subscription, setSelectedPlan }) {

  const [activePlan, setActivePlan] = useState(null);


  const handleSelectPlan = (plan) => {
    setActivePlan(plan.id);

    setSelectedPlan({
      ...plan,
      features: plan.description ? [plan.description] : []
    });
  };

  return (
    <div className='stepform_form Subscription_Plan'>
      <div className="Subscription_Plan_card_holder">
        <div className="row">

          {all_subscription?.length === 0 && (
            <p className="text-center text-muted">
              No subscription plans available.
            </p>
          )}
          {all_subscription?.map((plan) => (
            <div className="col-md-4" key={plan.id}>
              <Subscription_Plan_card
                title={plan.name}
                price={plan.final_price}
                duration={plan.validity}
               features={plan.description ? [parse(plan.description)] : []}  // FIXED
                isActive={activePlan === plan.id}
                onSelect={() => handleSelectPlan(plan)}
              />
            </div>
          ))}


        </div>
      </div>

      <div className='buttons'>
        <Button className="back_btn form_btn mt-4" onClick={prevStep}>
          Back
        </Button>

        <Button
          className="search_btn form_btn mt-4"
          onClick={() => {
            if (!activePlan) {
              alert("Please select a plan first.");
              return;
            }
            nextStep();
          }}
        >
          Save and Next
        </Button>
      </div>
    </div>
  );
}

export default Subscription_Plan;
